import logo from '../assets/logo.png'
import styled from 'styled-components'
import icoBack from '../assets/icons/back.svg'
import { useContext } from 'react'
import { ReservationContext } from '../context/ReservationContext'
import { OrderDataContext } from '../context/OrderDataContext'
import ltIcon from '../assets/icons/lt.svg'
import enIcon from '../assets/icons/gb.svg'
import { TranslationContext } from '../context/TranslationContext'

function Header ({ page, setPage, language, changeLanguage }) {
    const { reservation } = useContext(ReservationContext)
    const { order } = useContext(OrderDataContext)
    const { translations } = useContext(TranslationContext)

    const renderLeft = () => {
        if (page === 'menu' && !order.id && !order.success) {
            return <Back onClick={() => setPage('time')}><img src={icoBack} alt='back' /></Back>
        }
        if (page === 'confirm') {
            return <Back onClick={() => setPage('menu')}><img src={icoBack} alt='back' /></Back>
        }

        if (reservation.room !== '') {
            return <Room>{translations.room}<Number>{reservation.room}</Number></Room>
        }
    }

    const getLanguageLogo = () => {
        if (language !== 'LT') {
            return enIcon
        }
        return ltIcon
    }

    return (
        <Wrapper>
            <div>
                <Left>
                    {renderLeft()}
                </Left>
                <Center>
                    <Logo onClick={() => setPage(order.id || order.success ? 'menu' : 'time')}><img src={logo} style={{ margin: "0 auto", width: "163px", maxWidth: "163px" }} alt='boheme' /></Logo>
                </Center>
                <Right>
                    <LanguageSelector onClick={() => changeLanguage()}>
                        <img width="28"src={getLanguageLogo()} alt="Language selector" />
                    </LanguageSelector>
                </Right>
            </div>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    background: #3F4041;
    color: #AE996F;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding: 15px;
    z-index: 10;

    & > div {
        display: flex;
        width: 100%;
        max-width: 800px;
        align-items: center;
        justify-content: space-between;
        margin: 0 auto;
    }
`;

const Back = styled.div`
    cursor: pointer;
    img {
        height: 30px;
    }
`

const Logo = styled.div`
    cursor: pointer;
    img {
        margin: 0 auto;
    }
`

const Room = styled.div`
    text-align: center;
    font-size: 10px;
    float: left;
`

const LanguageSelector = styled.div`
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
    float: right;
    transition: color 0.3s ease-in;
    &:hover {
        color: #ffffff;
    }
`

const Number = styled.div`
    font-size: 20px;
`
const Left = styled.div`
    flex: 1;
`

const Center = styled.div`
    flex: 1;
    text-align: center;
`

const Right = styled.div`
    flex: 1;
`

export default Header;
